import selectedtraining_sttest_set_list from './selectedtraining/sttest_set_list';
import selectedtraining_assign_index from './selectedtraining/assign_index';
import selectedtraining_sttest_result from './selectedtraining/sttest_result';
import classPortfolio_external_exam from './classportfolio/external_exam';
import testcenter_result_users from './testcenter/result_users';
import selectedtraining_sttest_result_users from './selectedtraining/sttest_result_users';
import portfolio_analysis_homework_test from './portfolio/analysis/homework_test';

function buildChart($csv_chart_area, csv_download_url, papa_data) {
  if (csv_download_url.indexOf('/admin/selectedtraining/sttest_set_list.cfm') > -1) {
    selectedtraining_sttest_set_list($csv_chart_area, csv_download_url, papa_data);
  }

  if (window.location.href.indexOf('/admin/selectedtraining/assign_index.cfm') > -1) {
    selectedtraining_assign_index($csv_chart_area, csv_download_url, papa_data);
  }

  if (window.location.href.indexOf('/admin/selectedtraining/sttest_result.cfm') > -1) {
    selectedtraining_sttest_result($csv_chart_area, csv_download_url, papa_data);
  }

  if (window.location.href.indexOf('/admin/ClassPortfolio/external_exam.cfm') > -1) {
    classPortfolio_external_exam($csv_chart_area, csv_download_url, papa_data);
  }
  if (window.location.href.indexOf('/admin/testcenter/result_users.cfm') > -1) {
    testcenter_result_users($csv_chart_area, csv_download_url, papa_data);
  }

  if (window.location.href.indexOf('/admin/selectedtraining/sttest_result_users.cfm') > -1) {
    selectedtraining_sttest_result_users($csv_chart_area, csv_download_url, papa_data);
  }
  if (window.location.href.indexOf('/admin/aggregation/index') > -1) {
    portfolio_analysis_homework_test($csv_chart_area, csv_download_url, papa_data);
  }
  if (window.location.href.indexOf('/admin/aggregation/analysis') > -1) {
    portfolio_analysis_homework_test($csv_chart_area, csv_download_url, papa_data);
  }
}

export default buildChart;



// WEBPACK FOOTER //
// ./es6/admin-common-js/apps/csv_chart/charts/index.js